import { Box, Flex, Icon, Text, } from '@chakra-ui/react';
import { IoAirplaneOutline } from 'react-icons/io5';

type Details = {
  departure: string;
  arrival: string;
};

type FlightTileProps = {
  label: string;
  details: Details;
};

const grayColor = 'gray.400';

const DashedLine = () => (
  <Box
    w='100%'
    h={2} marginTop={1} marginX={3}
    color={grayColor}
    style={{
      backgroundImage: 'linear-gradient(to right, #000 10%, rgba(255, 255, 255, 0) 0%)',
      backgroundPosition: 'top',
      backgroundSize: '10px 4px',
      backgroundRepeat: 'repeat-x'
    }} />)

const FlightTile = ({ label, details }: FlightTileProps) => {
  return (
    <Box
      width='100%'
      padding={[3, 5]}
      boxShadow='3px 20px 25px -5px rgba(151, 151, 151, 0.1), 3px 10px 10px -5px rgba(151, 151, 151, 0.04)'
      borderRadius={[10, 20, 30]}
    >
      <Flex justifyContent='space-between'
      >
        <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>{label}</Text>
      </Flex>
      <Flex
        justifyContent='space-between'
        align='center'
        justify='center'
      >
        <Text fontFamily='Montserrat'
          fontSize={['16,20,24,36']}
          fontWeight={700} color='#000000'>
          {details.departure}
        </Text>
        <DashedLine />
        <Icon as={IoAirplaneOutline}
          width={[4, 6, 6, 8]}
          height={[4, 6, 6, 8]}
          color={grayColor}
        />
        <DashedLine />
        <Text fontFamily='Montserrat'
          fontSize={['16,20,24,36']}
          fontWeight={700} color='#000000'>
          {details.arrival}
        </Text>
      </Flex>
    </Box>
  );
};

export { FlightTile };
